'use strict';

// ****************** Form selectize ***********
$('#choose_mark').selectize({
    create: true,
    // sortField: 'text',
    placeholder: 'Выберите марку'
});

$('#choose_model').selectize({
    placeholder: 'Выберите модель'
});

$('#choose_gen').selectize({
    placeholder: 'Поколение'
});

$('#choose_modification').selectize({
    placeholder: 'Модификация'
});

$('#choose_category').selectize({
    placeholder: 'Категория вопроса'
});
// ======================================+++++++++

// ****************** Open-close ***********
var questionButton = document.querySelector('.e-btn.e-btn_consult');
var popup = document.querySelector('.popup');
var popupClose = document.querySelector('.popup__close');

questionButton && questionButton.addEventListener('click', function(evt) {
    evt.preventDefault();
    popup.classList.toggle('popup--hide');
});

window.document.addEventListener('keydown', function(evt) {
    if (evt.which === 27) {
        popup?     popup.classList.add('popup--hide'):false;
    }
});

popupClose && popupClose.addEventListener('click', function (evt) {
    popup.classList.add('popup--hide');
});
// =================================

$("#question_form").validate({
    ignore: ':hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input',
    rules: {
        'Question[contact_phone]': {
            required: true,
            phone: true,
        },
        name: {
            required: true,
        },
        // email: {
        //     required: true,
        //     maxlength: 128,
        //     email: true
        // },
        choose_mark: {
            required: true,
        },
        choose_model: {
            required: true,
        },
        choose_gen: {
            required: true,
        },
        choose_modification: {
            required: true,
        },
        choose_category: {
            required: true,
        },
        question: {
            required: true,
        }
    },
    errorPlacement: function(error, element) {
        console.log(element);
        console.log(element.parent("div"));
        console.log(element.parent("div").children('.help-block'));
        if (element[0].name === "Question[contact_phone]") {
            console.log('phone');
            element.parent("div").addClass('has-error99').removeClass('has-success');
            //element.parent("div").children('.help-block').text("Необходимо заполнить «Контактный телефон».");
        } else if (element[0].name === "Question[contact_email]") {
            element.parent("div").addClass('has-error').removeClass('has-success');
            //element.parent("div").children('.help-block').text("Необходимо заполнить «Контактный Email».")
        } else {
            return true;
        }
    },
    /*messages: {
          'Question[contact_phone]': {
              required: "error",
              phone: "Введите номер телефона",
          },
      },*/
});

var popup = document.querySelector('.popup');
if (popup) {
    var select = popup.querySelectorAll('.selectize-control.client-info__select');

    select.forEach(function (item) {
        item.addEventListener('click', function (evt) {
            item.parentNode.querySelector('select').classList.remove('error');
            item.parentNode.querySelector('label').style.display = 'none';
        });
    });
}

// Миниатюра для фотографии жилья
var imgChooser = document.querySelector('#form_photo');
var imgPreview = document.querySelector('.client-info__photos');

imgChooser && imgChooser.addEventListener('change', function () {
    var file = imgChooser.files[0];

    if (checkFile(file)) {
        var reader = new FileReader();

        reader.addEventListener('load', function () {
            var newImg = document.createElement('img');
            newImg.src = reader.result;
            newImg.style.width = '120px';
            imgPreview.appendChild(newImg);
        });

        reader.readAsDataURL(file);
    }
});

$("#form_photo_add").on('click', function(e){
    console.log('add photo');
    e.preventDefault();
    $('#form_photo').trigger('click');
});

// Проверяем наличие файла и его тип
var checkFile = function (file) {
    var FILE_TYPES = ['gif', 'jpg', 'jpeg', 'png'];
    if (file) {
        var fileName = file.name.toLowerCase();
        var matches = FILE_TYPES.some(function (it) {
            return fileName.endsWith(it);
        });
    }
    return matches;
};

$("#a_mark[data-trigger=dep-drop]").on("change", function() {
    var data = {};
    data[$(this).attr("data-name")] = $(this).val();
    var target = $(this).attr("data-target");
    $.getJSON(
        $(this).attr("data-url"),
        function(response, statusCode, xhr) {
            var slct = $(target);
            slct.empty();

            for (el in response) {
                $("<option value=\"" + el + "\">" + response[el] + "</option>").appendTo(slct);
            }

            slct.removeAttr("disabled");
        }
    );
});
